import { configureStore } from '@reduxjs/toolkit';
import fetchReducer from './reducers';

const apiClient = { /* ... */ };

export const store = configureStore({
  reducer: { user: fetchReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: { extraArgument: apiClient },
    }),
});
